"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bs58check_1 = __importDefault(require("bs58check"));
const bjs = __importStar(require("bitcoinjs-lib"));
const errors_1 = require("@ledgerhq/errors");
const base_1 = __importDefault(require("./base"));
class ZCash extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        this.network = network;
        this.network.dustThreshold = 10000;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
    getLegacyAddress(xpub, account, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const pk = bjs.crypto.hash160(yield this.getPubkeyAt(xpub, account, index));
            const payload = Buffer.allocUnsafe(22);
            payload.writeUInt16BE(this.network.pubKeyHash, 0);
            pk.copy(payload, 2);
            return bs58check_1.default.encode(payload);
        });
    }
    customGetAddress(derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getLegacyAddress(xpub, account, index);
        });
    }
    toOutputScript(address) {
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        const version = Number("0x" + bs58check_1.default.decode(address).slice(0, 2).toString("hex"));
        if (version === this.network.pubKeyHash) {
            //Pay-to-PubkeyHash
            return bjs.payments.p2pkh({ hash: bs58check_1.default.decode(address).slice(2) }).output;
        }
        if (version === this.network.scriptHash) {
            //Pay-to-Script-Hash
            return bjs.payments.p2sh({ hash: bs58check_1.default.decode(address).slice(2) }).output;
        }
        throw new errors_1.InvalidAddress();
    }
    validateAddress(address) {
        try {
            const version = Number("0x" + bs58check_1.default.decode(address).slice(0, 2).toString("hex"));
            // refer to https://github.com/zcash-hackworks/bitcore-lib-zcash/blob/master/lib%2Faddress.js for the address validation
            if (version === this.network.pubKeyHash || version === this.network.scriptHash) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
}
exports.default = ZCash;
//# sourceMappingURL=zec.js.map